/*  ============
  Actions for the auth module
  ============

  The actions that are available on the
  auth module.

 */

import * as types from "./mutation-types";

export const set_list = ({ commit, state }, data) => {

    const now = new Date();

    const item = {
        value: data.value,
        expiry: now.getTime() + state.ttl
    };

    const cache_key = state.generate_key(data.url, data.params);

    commit(types.SET_LIST, { key: cache_key, value: JSON.stringify(item) });

    // localStorage.setItem(data.key, JSON.stringify(item));
    // console.log('before store ', item);
    // commit(types.SET_LIST, { key: data.key, value: JSON.stringify(item) });

};


export default {
    set_list,
};
